import React from "react";
import "./Ringer.scss"
import ringer from "../../../assets/icons/ringer.png";

const Ringer = () => {
  return <img className="Ringer" src={ringer} alt="" />;
};

export default Ringer;
